import { Tag } from 'antd'
import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { BizTypeColorMap, BizTypeTextMap } from '@eastcoal/shared/enums/BizType'

import { BizTypeTagProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  tag: {
    margin: 0
  }
}))

export const BizTypeTag = ({
  type,
  className,
  ...restProps
}: BizTypeTagProps) => {
  const presetColor = isNil(type) ? 'gold' : BizTypeColorMap[type]
  const text = isNil(type) ? 'NA' : BizTypeTextMap[type]

  const { cx, styles } = useStyles()

  return (
    <Tag
      className={cx(styles.tag, className)}
      variant='filled'
      {...restProps}
      color={presetColor}
    >
      {text}
    </Tag>
  )
}
